import { getIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/getIsNav4Enabled.ts';

/**
 * A bunch of Confluence unit tests mock some underlying dependencies of this check.
 */
export const getIsNav4EnabledSafe = (): boolean => {
	try {
		return getIsNav4Enabled();
	} catch {
		return false;
	}
};
